import { FC } from 'react'
import createStandardIcon from './createStandardIcon'
import type { IconProps } from './type'

const CheckFilledIconSvg: FC<IconProps> = (props) => {
  return (
    <svg viewBox="0 0 21 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect x="0.5" width="20" height="20" rx="10" fill={props.fill} />
      <path
        d="M8.90507 9.93354C9.2307 10.1084 9.44284 10.2536 9.69541 10.5127C10.3504 9.53107 11.1406 8.43416 12.065 7.66208L12.1554 7.62964H13.1668C11.8106 9.03225 10.7514 10.6792 9.73804 12.3704C9.12897 11.4146 8.7191 10.7993 7.8335 10.159L8.90507 9.93354Z"
        fill="white"
      />
    </svg>
  )
}

export const CheckFilledIcon = createStandardIcon(CheckFilledIconSvg)
